export const en: Record<string, string> = {
  "dashboard.nav.myItems": "My Items",
  "dashboard.accountMenu.myItems": "My items",
  "dashboard.focused.items": "My Items",
  "dashboard.focused.loadingItems": "Loading items…",
  "dashboard.focused.retryItems": "Retry",
  "dashboard.focused.listItem": "List an item",
  "dashboard.focused.emptyItems": "You haven’t listed any items yet.",
  "dashboard.myQuotes": "My Quotes",
  "dashboard.nav.myServices": "My Services",
  "dashboard.nav.myCompany": "My Company",
  "dashboard.nav.myJobs": "My Jobs",
  "dashboard.nav.hiring": "Hiring",
  "dashboard.nav.myProjects": "My Projects",
  "dashboard.nav.myBids": "My Bids",
  "dashboard.nav.myApplications": "My Applications",
  "dashboard.nav.messages": "Messages",
  "dashboard.nav.contracts": "Contracts",
  "dashboard.nav.wallet": "Wallet / Escrow",
  "dashboard.nav.saved": "Saved Items",
  "dashboard.nav.settings": "Settings",
  "dashboard.nav.logout": "Log out",
  "dashboard.accountMenu.title": "Account menu",
  "dashboard.accountMenu.account": "Account",
  "dashboard.accountMenu.more": "View more",
  "dashboard.accountMenu.less": "View less",
  "dashboard.accountMenu.myServices": "My services",
  "dashboard.accountMenu.myCompany": "My company",
  "dashboard.accountMenu.myJobs": "My jobs",
  "dashboard.accountMenu.hiring": "Hiring",
  "dashboard.accountMenu.myProjects": "My projects",
  "dashboard.accountMenu.myBids": "My bids",
  "dashboard.accountMenu.myApplications": "Applications",
  "dashboard.accountMenu.messages": "Messages",
  "dashboard.accountMenu.contracts": "Contracts",
  "dashboard.accountMenu.wallet": "Wallet",
  "dashboard.accountMenu.saved": "Saved items",
  "dashboard.accountMenu.settings": "Settings",
  "dashboard.quickStart.title": "Your quick start",
  "dashboard.quickStart.role.employer": "Employer",
  "dashboard.quickStart.role.client": "Client",
  "dashboard.quickStart.role.worker": "Jobseeker",
  "dashboard.quickStart.role.supplier": "Supplier",
  "dashboard.quickStart.stat.jobs": "jobs posted",
  "dashboard.quickStart.stat.projects": "projects & RFQs",
  "dashboard.quickStart.stat.services": "services listed",
  "dashboard.quickStart.stat.companies": "companies",
  "dashboard.quickStart.action.postJob": "Post a job",
  "dashboard.quickStart.action.findJobseekers": "Find jobseekers",
  "dashboard.quickStart.action.postProject": "Post a project",
  "dashboard.quickStart.action.browseServices": "Browse services",
  "dashboard.quickStart.action.offerService": "Offer a service",
  "dashboard.quickStart.action.browseJobs": "Browse jobs",
  "dashboard.quickStart.action.sellItem": "Sell an item",
  "dashboard.quickStart.action.discoverCompanies": "Discover companies",
  "dashboard.profile.complete": "Complete profile setup",
  "dashboard.profile.setup": "Set up your profile",
  "dashboard.completion.title": "Profile setup",
  "dashboard.profileComplete": "Profile setup complete",
  "dashboard.completion.help": "Jobseeker requirements are checked separately.",
  "dashboard.completionUnavailable": "Open your profile to check setup.",
  "dashboard.profile.edit": "Edit profile",
  "dashboard.profile.start": "Start onboarding",
  "dashboard.profile.completeness": "profile setup. Jobseeker requirements are checked separately.",
  "dashboard.activities.title": "Your Activities",
  "dashboard.activities.subtitle": "One account, multiple activities — add more anytime",
  "dashboard.activities.empty": "No activities yet.",
  "dashboard.overview.jobs": "Jobs Posted",
  "dashboard.overview.projects": "Projects Posted",
  "dashboard.overview.rfqs": "RFQs Posted",
  "dashboard.overview.services": "Services Listed",
  "dashboard.overview.resumes": "Résumés",
  "dashboard.companies.title": "My Companies",
  "dashboard.companies.new": "New company",
  "dashboard.workspace.listings": "Listings",
  "dashboard.workspace.work": "Work",
  "dashboard.workspace.orders": "Orders",
  "dashboard.workspace.sections": "Dashboard sections",
  "dashboard.workspace.emptyOrders": "Your purchases, sales, and reviews will appear here.",
  "dashboard.listings.title": "My Listings",
  "dashboard.listings.description": "Manage and monitor your posts in one place.",
  "dashboard.listings.matching": "matching",
  "dashboard.listings.search": "Search listing titles…",
  "dashboard.listings.allTypes": "All types",
  "dashboard.listings.allStatus": "All status",
  "dashboard.listings.nothingPosted": "Nothing posted yet.",
  "dashboard.listings.noMatch": "No listings match these filters.",
  "dashboard.engagements.title": "Work & Engagements",
  "dashboard.engagements.description": "Track hired work with a shared checklist.",
  "dashboard.status.archived": "Archived",
  "dashboard.status.awarded": "Awarded",
  "dashboard.status.shortlisting": "Shortlisting",
  "dashboard.status.openBidding": "Open for Bidding",
  "dashboard.status.archivedLabel": "Archived",
  "dashboard.status.live": "Live",
  "dashboard.status.closed": "Closed",
  "dashboard.status.hidden": "Hidden",
  "dashboard.service.close": "Close service",
  "dashboard.service.archive": "Archive",
  "dashboard.service.restore": "Restore to closed",
  "dashboard.status.featured": "Featured",
  "dashboard.focused.back": "Back to dashboard",
  "dashboard.focused.resume": "My Résumés",
  "dashboard.focused.services": "My Services",
  "dashboard.focused.jobs": "My Jobs",
  "dashboard.focused.projects": "My Projects",
  "dashboard.focused.company": "My Company",
  "dashboard.focused.bids": "My Bids",
  "dashboard.focused.manageResumes": "Manage résumé files",
  "dashboard.focused.offerService": "Offer a service",
  "dashboard.focused.postJob": "Post a job",
  "dashboard.focused.postProject": "Post a project",
  "dashboard.focused.newCompany": "New company",
  "dashboard.focused.browseProjects": "Browse projects",
  "dashboard.focused.emptyResume": "No legacy résumé listings. Manage your résumé files on your profile.",
  "dashboard.focused.emptyServices": "You haven't listed any services yet.",
  "dashboard.focused.emptyJobs": "You haven't posted any jobs yet.",
  "dashboard.focused.emptyProjects": "You haven't posted any projects yet.",
  "dashboard.focused.emptyCompanies": "You don't own or belong to any companies yet.",
  "dashboard.focused.emptyBids": "You haven't placed any bids yet.",
  "dashboard.focused.bidCount": "Bids",
  "dashboard.focused.biddingDeadline": "Bidding deadline",
  "dashboard.focused.estimatedBudget": "Estimated budget",
  "dashboard.focused.notProvided": "Not provided",
  "dashboard.focused.viewProject": "View project",
  "dashboard.applications.title": "My Applications",
  "dashboard.applications.browseJobs": "Browse jobs",
  "dashboard.applications.empty": "You haven't applied to any jobs yet.",
  "dashboard.applications.postJob": "Post a job",
  "dashboard.activities.enable": "Enable:",
  "dashboard.activity.findWork": "Find Work",
  "dashboard.activity.offerService": "Offer a Service",
  "dashboard.activity.promoteCompany": "Promote a Company",
  "dashboard.activity.hire": "Hire Someone",
  "dashboard.activity.postJob": "Post a Job",
  "dashboard.activity.postProject": "Post a Project",
};

export const tl: Record<string, string> = {
  "dashboard.nav.myItems": "Aking mga Item",
  "dashboard.accountMenu.myItems": "Mga item",
  "dashboard.focused.items": "Aking mga Item",
  "dashboard.focused.loadingItems": "Nilo-load ang mga item…",
  "dashboard.focused.retryItems": "Subukan muli",
  "dashboard.focused.listItem": "Maglista ng item",
  "dashboard.focused.emptyItems": "Wala ka pang nakalistang item.",
  "dashboard.myQuotes": "Aking mga quote",
  "dashboard.quickStart.title": "Magsimula",
  "dashboard.quickStart.role.employer": "Employer",
  "dashboard.quickStart.role.client": "Kliyente",
  "dashboard.quickStart.role.worker": "Naghahanap ng trabaho",
  "dashboard.quickStart.role.supplier": "Supplier",
  "dashboard.quickStart.stat.jobs": "trabahong na-post",
  "dashboard.quickStart.stat.projects": "proyekto at RFQ",
  "dashboard.quickStart.stat.services": "serbisyong nakalista",
  "dashboard.quickStart.stat.companies": "kompanya",
  "dashboard.quickStart.action.postJob": "Mag-post ng trabaho",
  "dashboard.quickStart.action.findJobseekers": "Humanap ng jobseeker",
  "dashboard.quickStart.action.postProject": "Mag-post ng proyekto",
  "dashboard.quickStart.action.browseServices": "Tumingin ng serbisyo",
  "dashboard.quickStart.action.offerService": "Mag-alok ng serbisyo",
  "dashboard.quickStart.action.browseJobs": "Tumingin ng trabaho",
  "dashboard.quickStart.action.sellItem": "Magbenta ng item",
  "dashboard.quickStart.action.discoverCompanies": "Tuklasin ang kompanya",
  "dashboard.nav.myServices": "Aking mga Serbisyo",
  "dashboard.nav.myCompany": "Aking Kompanya",
  "dashboard.nav.myJobs": "Aking mga Trabaho",
  "dashboard.nav.hiring": "Pagkuha ng Empleyado",
  "dashboard.nav.myProjects": "Aking mga Proyekto",
  "dashboard.nav.myBids": "Aking mga Bid",
  "dashboard.nav.myApplications": "Aking mga Aplikasyon",
  "dashboard.nav.messages": "Mga Mensahe",
  "dashboard.nav.contracts": "Mga Kontrata",
  "dashboard.nav.wallet": "Pitaka / Escrow",
  "dashboard.nav.saved": "Mga Naka-save na Item",
  "dashboard.nav.settings": "Mga Setting",
  "dashboard.nav.logout": "Mag-log out",
  "dashboard.accountMenu.title": "Menu ng account",
  "dashboard.accountMenu.account": "Account",
  "dashboard.accountMenu.more": "Tingnan pa",
  "dashboard.accountMenu.less": "Kaunti",
  "dashboard.accountMenu.myServices": "Mga serbisyo",
  "dashboard.accountMenu.myCompany": "Kompanya",
  "dashboard.accountMenu.myJobs": "Mga trabaho",
  "dashboard.accountMenu.hiring": "Hiring",
  "dashboard.accountMenu.myProjects": "Mga proyekto",
  "dashboard.accountMenu.myBids": "Mga bid",
  "dashboard.accountMenu.myApplications": "Aplikasyon",
  "dashboard.accountMenu.messages": "Mensahe",
  "dashboard.accountMenu.contracts": "Kontrata",
  "dashboard.accountMenu.wallet": "Pitaka",
  "dashboard.accountMenu.saved": "Na-save",
  "dashboard.accountMenu.settings": "Mga setting",
  "dashboard.profile.complete": "Kumpletuhin ang pag-set up ng profile",
  "dashboard.profile.setup": "I-set up ang profile mo",
  "dashboard.completion.title": "Pag-set up ng profile",
  "dashboard.profileComplete": "Kumpleto na ang pag-set up ng profile",
  "dashboard.completion.help": "Hiwalay na sinusuri ang mga kailangan sa Jobseekers.",
  "dashboard.completionUnavailable": "Buksan ang profile para tingnan ang pag-set up.",
  "dashboard.profile.edit": "I-edit ang profile",
  "dashboard.profile.start": "Simulan ang pag-set up",
  "dashboard.profile.completeness": "ng pag-set up ng profile. Hiwalay na sinusuri ang mga kailangan sa Jobseekers.",
  "dashboard.activities.title": "Mga Aktibidad Mo",
  "dashboard.activities.subtitle": "Isang account para sa maraming aktibidad — magdagdag anumang oras",
  "dashboard.activities.empty": "Wala pang aktibidad.",
  "dashboard.overview.jobs": "Mga Naipost na Trabaho",
  "dashboard.overview.projects": "Mga Naipost na Proyekto",
  "dashboard.overview.rfqs": "Mga Naipost na RFQ",
  "dashboard.overview.services": "Mga Serbisyong Nakalista",
  "dashboard.overview.resumes": "Mga Résumé",
  "dashboard.companies.title": "Aking mga Kompanya",
  "dashboard.companies.new": "Bagong kompanya",
  "dashboard.workspace.listings": "Mga Listahan",
  "dashboard.workspace.work": "Trabaho",
  "dashboard.workspace.orders": "Mga Order",
  "dashboard.workspace.sections": "Mga seksyon ng dashboard",
  "dashboard.workspace.emptyOrders": "Dito makikita ang iyong mga binili, benta, at review.",
  "dashboard.listings.title": "Aking mga listing",
  "dashboard.listings.description": "Pamahalaan at subaybayan ang iyong mga post sa iisang lugar.",
  "dashboard.listings.matching": "tugma",
  "dashboard.listings.search": "Maghanap ng pamagat ng listahan…",
  "dashboard.listings.allTypes": "Lahat ng uri",
  "dashboard.listings.allStatus": "Lahat ng status",
  "dashboard.listings.nothingPosted": "Wala ka pang naipost.",
  "dashboard.listings.noMatch": "Walang listahang tumutugma sa mga filter na ito.",
  "dashboard.engagements.title": "Trabaho at mga Engagement",
  "dashboard.engagements.description": "Subaybayan ang nakuhang trabaho gamit ang pinagsasaluhang checklist.",
  "dashboard.status.archived": "Naka-archive",
  "dashboard.status.awarded": "Iginawad",
  "dashboard.status.shortlisting": "Pagpili ng shortlist",
  "dashboard.status.openBidding": "Bukas para sa pag-bid",
  "dashboard.status.archivedLabel": "Naka-archive",
  "dashboard.status.live": "Aktibo",
  "dashboard.status.closed": "Sarado",
  "dashboard.status.hidden": "Nakatago",
  "dashboard.service.close": "Isara ang serbisyo",
  "dashboard.service.archive": "I-archive",
  "dashboard.service.restore": "Ibalik bilang sarado",
  "dashboard.status.featured": "Tampok",
  "dashboard.focused.back": "Bumalik sa dashboard",
  "dashboard.focused.resume": "Aking mga Résumé",
  "dashboard.focused.services": "Aking mga Serbisyo",
  "dashboard.focused.jobs": "Aking mga Trabaho",
  "dashboard.focused.projects": "Aking mga Proyekto",
  "dashboard.focused.company": "Aking Kompanya",
  "dashboard.focused.bids": "Aking mga Bid",
  "dashboard.focused.manageResumes": "Pamahalaan ang mga résumé file",
  "dashboard.focused.offerService": "Mag-alok ng serbisyo",
  "dashboard.focused.postJob": "Mag-post ng trabaho",
  "dashboard.focused.postProject": "Mag-post ng proyekto",
  "dashboard.focused.newCompany": "Bagong kompanya",
  "dashboard.focused.browseProjects": "Mag-browse ng mga proyekto",
  "dashboard.focused.emptyResume": "Wala pang lumang listahan ng résumé. Pamahalaan ang mga résumé file sa iyong profile.",
  "dashboard.focused.emptyServices": "Wala ka pang nakalistang serbisyo.",
  "dashboard.focused.emptyJobs": "Wala ka pang naipost na trabaho.",
  "dashboard.focused.emptyProjects": "Wala ka pang naipost na proyekto.",
  "dashboard.focused.emptyCompanies": "Wala ka pang kompanyang pag-aari o kinabibilangan.",
  "dashboard.focused.emptyBids": "Wala ka pang naisumiteng bid.",
  "dashboard.focused.bidCount": "Mga Bid",
  "dashboard.focused.biddingDeadline": "Takdang oras ng pag-bid",
  "dashboard.focused.estimatedBudget": "Tinatayang badyet",
  "dashboard.focused.notProvided": "Hindi ibinigay",
  "dashboard.focused.viewProject": "Tingnan ang proyekto",
  "dashboard.applications.title": "Aking mga Aplikasyon",
  "dashboard.applications.browseJobs": "Mag-browse ng trabaho",
  "dashboard.applications.empty": "Wala ka pang inaplayang trabaho.",
  "dashboard.applications.postJob": "Mag-post ng trabaho",
  "dashboard.activities.enable": "I-enable:",
  "dashboard.activity.findWork": "Maghanap ng Trabaho",
  "dashboard.activity.offerService": "Mag-alok ng Serbisyo",
  "dashboard.activity.promoteCompany": "I-promote ang Kompanya",
  "dashboard.activity.hire": "Mag-hire ng Tao",
  "dashboard.activity.postJob": "Mag-post ng Trabaho",
  "dashboard.activity.postProject": "Mag-post ng Proyekto",
};
